import Chartie from "./chartie.service";

const chartieModule = angular
  .module("app.services.chartie", [])
  .service("Chartie", Chartie);

export default chartieModule;



// WEBPACK FOOTER //
// ./src/services/chartie/chartie.module.js